(function () {
  const alignNav = (section, swiper) => {
    const instance = swiper || section._dealsSwiper;
    if (!instance || window.matchMedia('(max-width: 749px)').matches) {
      section.style.removeProperty('--deals-nav-inset');
      return;
    }
    const perView = Number(instance.params.slidesPerView) || 1;
    const whole = Math.floor(perView);
    if (whole < 1 || whole === perView) {
      section.style.setProperty('--deals-nav-inset', '0px');
      return;
    }
    const box = instance.el.getBoundingClientRect();
    const slides = [...instance.slides]
      .map((slide) => slide.getBoundingClientRect())
      .filter((rect) => rect.width > 0 && rect.left >= box.left - 1 && rect.left < box.right - 1)
      .sort((a, b) => a.left - b.left);
    const target = slides[whole - 1];
    if (!target) return;
    section.style.setProperty('--deals-nav-inset', `${Math.max(0, Math.round(box.right - target.right))}px`);
  };

  const uniquifyClones = (swiper) => {
    swiper.el.querySelectorAll('.swiper-slide-duplicate:not([data-clone-ready])').forEach((slide, slideIndex) => {
      const map = new Map();
      slide.querySelectorAll('[id]').forEach((node) => {
        map.set(node.id, `${node.id}-clone-${slideIndex}`);
      });
      slide.querySelectorAll('[id]').forEach((node) => {
        node.id = map.get(node.id);
      });
      slide.querySelectorAll('[for]').forEach((node) => {
        const next = map.get(node.getAttribute('for'));
        if (next) node.setAttribute('for', next);
      });
      ['aria-labelledby', 'aria-controls', 'aria-describedby'].forEach((attr) => {
        slide.querySelectorAll(`[${attr}]`).forEach((node) => {
          const next = node
            .getAttribute(attr)
            .split(/\s+/)
            .map((token) => map.get(token) || token)
            .join(' ');
          node.setAttribute(attr, next);
        });
      });
      slide.querySelectorAll('input[name]').forEach((input) => {
        if (input.name === 'id' || input.name === 'quantity') return;
        input.name = `${input.name}-clone-${slideIndex}`;
      });
      slide.querySelectorAll('quick-add-modal').forEach((modal) => modal.remove());
      slide.dataset.cloneReady = 'true';
    });
  };

  const lockSwiperScroll = (el) => {
    if (!el || el.dataset.scrollLocked === 'true') return;
    el.dataset.scrollLocked = 'true';
    const reset = () => {
      let node = el;
      const stop = el.closest('.section-anniversary-hottest-deals');
      while (node && node !== stop) {
        if (node.scrollLeft) node.scrollLeft = 0;
        node = node.parentElement;
      }
    };
    el.addEventListener('scroll', reset, { passive: true });
    el.addEventListener('focusin', () => {
      reset();
      window.requestAnimationFrame(reset);
    });
  };

  const initSection = (section) => {
    if (section.dataset.dealsReady === 'true') return;
    const el = section.querySelector('.hottest-deals__swiper');
    if (!el || typeof window.Swiper === 'undefined') return;

    const count = el.querySelectorAll('.swiper-slide').length;
    if (count < 1) return;

    const parsedView = Number(section.dataset.slidesPerView);
    const maxView = Number.isFinite(parsedView) && parsedView >= 1 ? parsedView : 4.35;
    const parsedMobile = Number(section.dataset.slidesPerViewMobile);
    const mobileView = Number.isFinite(parsedMobile) && parsedMobile >= 1 ? parsedMobile : 1;
    const parsedGap = Number(section.dataset.mobileSlideGap);
    const mobileGap = Number.isFinite(parsedGap) && parsedGap >= 0 ? parsedGap : mobileView > 1 ? 8 : 0;
    const viewAt = (offset) => Math.max(1, maxView - offset);
    section._dealsSwiper = new window.Swiper(el, {
      slidesPerView: mobileView,
      spaceBetween: mobileGap,
      slidesPerGroup: 1,
      speed: 450,
      loop: count > maxView + 1,
      loopAdditionalSlides: 2,
      watchOverflow: true,
      watchSlidesProgress: true,
      slideToClickedSlide: false,
      noSwiping: true,
      noSwipingSelector: 'color-change-component',
      roundLengths: true,
      grabCursor: true,
      navigation: {
        prevEl: section.querySelector('.hottest-deals__arrow--prev'),
        nextEl: section.querySelector('.hottest-deals__arrow--next'),
      },
      breakpoints: {
        750: {
          slidesPerView: viewAt(2),
          spaceBetween: 16,
        },
        1001: {
          slidesPerView: viewAt(1),
          spaceBetween: 16,
        },
        1201: {
          slidesPerView: maxView,
          spaceBetween: 16,
        },
      },
      on: {
        init(swiper) {
          uniquifyClones(swiper);
          alignNav(section, swiper);
        },
        breakpoint(swiper) {
          uniquifyClones(swiper);
          alignNav(section, swiper);
        },
        resize(swiper) {
          alignNav(section, swiper);
        },
      },
    });

    section.dataset.dealsReady = 'true';
    lockSwiperScroll(el);
    alignNav(section);
  };

  const boot = (root) => {
    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(() => boot(root), 50);
      return;
    }
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.section-anniversary-hottest-deals').forEach((section) => {
      initSection(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.section-anniversary-hottest-deals');
    if (section && section._dealsSwiper) {
      section._dealsSwiper.destroy(true, true);
      section._dealsSwiper = null;
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.section-anniversary-hottest-deals').forEach((section) => {
      alignNav(section);
    });
  });
})();
